import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";
export const getSlidersFunc = createAsyncThunk(
  "getAllSliders",
  async (query = "", thunkAPI) => {
    try {
      const res = await api.get(`dashboard/general-settings/sliders${query}`);
      
      return res.data.data.sliders;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const getSlidersSlicer = createSlice({
  name: "getAllSliders",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducer: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSlidersFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getSlidersFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(getSlidersFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getSlidersSlicer.reducer;
